import { render, staticRenderFns } from "./ProductSizeImages.vue?vue&type=template&id=220dcd3e&scoped=true&"
import script from "./ProductSizeImages.vue?vue&type=script&lang=js&"
export * from "./ProductSizeImages.vue?vue&type=script&lang=js&"
import style0 from "@@/core/components/product/ProductSizeImages/ProductSizeImagesStyle.css?vue&type=style&index=0&id=220dcd3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220dcd3e",
  null
  
)

export default component.exports